import { useAdminAuth } from '../../shared/auth/admin-auth-context'
import { RecipientCard } from './recipient-card'
import { notificationsErrorText, useNotificationSettings } from './queries'
import expert from '../../shared/ui/expert.module.css'

export function NotificationsPage() {
  const { user, status } = useAdminAuth()
  const staff = status === 'authenticated' && (user?.role === 'admin' || user?.role === 'expert')
  const settings = useNotificationSettings()

  if (!staff) return <p className="error-box">Раздел доступен только сотрудникам.</p>

  const data = settings.data
  const limits = { staleHours: data?.stale_hours ?? 12, repeatMinutes: data?.repeat_minutes ?? 10 }

  return (
    <div>
      <header className={expert.head}>
        <div>
          <h1>Уведомления</h1>
          <p className="muted">
            Telegram-уведомления о разборах приходят из бота Lunary. Чтобы бот мог писать, откройте его в Telegram и нажмите /start. Имена и контакты клиентов в
            уведомления не попадают.
          </p>
        </div>
      </header>
      {settings.isError && (
        <p className="error-box" role="alert">
          {notificationsErrorText(settings.error)}
        </p>
      )}
      {data && !data.delivery_enabled && (
        <p className="error-box" role="status">
          Отправка выключена: на сервере не настроен бот или список получателей (TELEGRAM_STAFF_RECIPIENTS).
        </p>
      )}
      {data && data.recipients.length === 0 && (
        <p className="muted">
          {user?.role === 'admin'
            ? 'Получателей нет. Добавьте Telegram ID в TELEGRAM_STAFF_RECIPIENTS на сервере.'
            : 'Ваш аккаунт не связан с Telegram, на который приходят уведомления. Войдите в админку через Telegram или попросите администратора.'}
        </p>
      )}
      {data?.recipients.map((r) => <RecipientCard key={r.telegram_id} recipient={r} limits={limits} />)}
    </div>
  )
}
